export const SETTINGS_MODAL = 'settings-modal'
export const END_CONVERSATION_CONFIRM_MODAL = 'end-conversation-confirm-modal'
